/**
* Widgets Functions
*/
export default function () {
  const { currentPath, layout } = useHelpers()

  /**
  * Assign Widget Options
  */
  function mergeObjectsWithConsideration (primary, secondary) {
    const merged = { ...secondary }

    for (const key in primary) {
      const primaryHasKey = Object.prototype.hasOwnProperty.call(primary, key)
      const secondaryHasKey = Object.prototype.hasOwnProperty.call(secondary, key)

      if (primaryHasKey && (primary[key] !== '' && (!Array.isArray(primary[key]) || primary[key].length > 0))) {
        merged[key] = primary[key]
      } else if (secondaryHasKey && Array.isArray(secondary[key]) && secondary[key].length > 0) {
        merged[key] = secondary[key]
      } else if (primaryHasKey && (primary[key] === '' || (Array.isArray(primary[key]) && primary[key].length === 0))) {
        merged[key] = secondary[key]
      }
    }

    return merged
  }

  const assignWidgetOptions = (widgetDefaultData, widgetData = {}) => {
    if (widgetDefaultData) {
      if (widgetData) {
        return mergeObjectsWithConsideration(widgetData, widgetDefaultData)
        // return Object.assign({}, widgetDefaultData, widgetData)
      } else {
        return widgetDefaultData
      }
    } else if (widgetData) {
      return widgetData
    } else {
      return ''
    }
  }

  /**
  * Hide Widget relatively settings
  * Example:
  * hideOn: ['/(.*)', layout-notFound],
  * showOn: ['/page/thank-you-108', '/page/success-155', layout-notFound]
  */
  const hideWidget = (arr) => {
    if (arr) {
      if (arr.showOn && arr.showOn.some((pattern) => {
        if (pattern === `layout-${layout.value}`) {
          return false
        }
        
        if (pattern.startsWith('/') && !pattern.includes('(')) {
          return pattern === currentPath.value
        } else {
          const regex = new RegExp('^' + pattern + '$')
          return regex.test(currentPath.value)
        }
      })) {
        return false
      }

      if (arr.hideOn && arr.hideOn.some((pattern) => {
        if (layout.value === 'notFound' && pattern !== 'layout-notFound') { 
          return false
        }
        
        if (pattern === `layout-${layout.value}`) {
          return true
        }

        if (pattern.startsWith('/') && !pattern.includes('(')) {
          return pattern === currentPath.value
        } else {
          const regex = new RegExp('^' + pattern + '$')
          return regex.test(currentPath.value)
        }
      })) {
        return true
      }
    }

    return false
  }

  /**
  * widget Сondition
  * Example:
  * darkMode: ['/(.*)', '/page/on-demand-platform-12'],
  */
  const widgetCondition = (arrCondition) => {
    if (arrCondition) {
      if (arrCondition?.some((pattern) => {
        if (pattern === `layout-${layout.value}`) {
          return false
        }

        if (pattern.startsWith('/') && !pattern.includes('(')) {
          return pattern === currentPath.value
        } else {
          const regex = new RegExp('^' + pattern + '$')
          return regex.test(currentPath.value)
        }
      })) {
        return true
      }
    }
    
    return false
  }

  /**
  * Return Object
  */
  return {
    assignWidgetOptions,
    hideWidget,
    widgetCondition
  }
}
